export default {
  DATA_CHANGE: 'WindSpeedRoseDataChange',
  LNG_LAT_CHANGE: 'WindSpeedRoseLngLatChange',
  CLEAR: 'WindSpeedRoseClear'
}



// WEBPACK FOOTER //
// ./src/components/MapTools/WindSpeedRose/eventKeyMap.js